import { Switch } from "./ui/switch";
import { INVENTORY_GROUPS } from "../lib/inventory";

export default function InventoryChecklist({ value, onChange }) {
  const toggle = (id) => onChange({ ...value, [id]: !value[id] });
  return (
    <div className="space-y-6">
      {INVENTORY_GROUPS.map((group) => (
        <div
          key={group.id}
          className="bg-white border border-sand rounded-xl overflow-hidden"
        >
          <div className="px-5 py-3 border-b border-sand bg-ivory">
            <h4 className="font-semibold text-charcoal">{group.label}</h4>
          </div>
          <ul className="divide-y divide-sand">
            {group.items.map((item) => (
              <li
                key={item.id}
                className="px-5 py-3 flex items-center justify-between"
              >
                <span className="text-sm text-charcoal">{item.label}</span>
                <Switch
                  checked={Boolean(value[item.id])}
                  onCheckedChange={() => toggle(item.id)}
                  data-testid={`inventory-${item.id}`}
                />
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}
